// 个人中心板块
import request from '@/utils/request'

// 获取用户信息
export const getUserInfo = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_APPSERVER + '/api/iUserInfo/getUser',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 分页查询用户导出记录
export const queryexportRecordPager = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_APPSERVER + '/api/exportRecord/exportRecordPager',
		method: 'get',
		headers: {
			isToken: true
		},
		params
	})
}

// 用户收藏
export const saveUserCollect = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/userCollect/saveUserCollect',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 用户取消收藏
export const removeUserCollect = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/userCollect/removeUserCollect',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 查询用户收藏的政策资讯信息
export const pageUserCollectPolicy = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/userCollect/pageUserCollectPolicy',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询用户收藏的资质查-项目信息
export const pageUserCollectProject = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/userCollect/pageUserCollectProject',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询用户收藏的资质查-人员信息
export const pageUserCollectPerson = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/userCollect/pageUserCollectPerson',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询用户收藏的资质查-企业信息
export const pageUserCollectUnit = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/userCollect/pageUserCollectUnit',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 用户订阅政策资讯信息
export const subscribePolicy = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_APPSERVER + '/api/iPolicyFlash/subscribePolicy',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 用户取消订阅政策快讯信息
export const unSubscribePolicy = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_APPSERVER + '/api/iPolicyFlash/unSubscribePolicy',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 查询用户订阅的政策快讯信息
export const pageUserSubscribePolicy = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_APPSERVER + '/api/iPolicyFlash/pageUserSubscribePolicy',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 根据用户订阅的类型查询政策资讯信息（即平台推送）
export const pageUserSubscribePolicyByType = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_APPSERVER + '/api/iPolicyFlash/pageUserSubscribePolicyByType',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 用户监控
export const saveUserMonitoring = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/userMonitoring/saveUserMonitoring',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 用户取消监控
export const removeUserMonitoring = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/userMonitoring/removeUserMonitoring',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}
